import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }

  text_answer_validation(original_answer, given_answer) {
    var ga = JSON.stringify(given_answer).replace(/ /g, "").toLowerCase()
    var splitted_answers = original_answer.split("|");
    for (var i = 0; i < splitted_answers.length; i++) {
      splitted_answers[i] = JSON.stringify(splitted_answers[i]).replace(/ /g, "").toLowerCase();
    };
    return splitted_answers.indexOf(ga) > -1;
  }

  single_option_validation(original_answers, selected_option) {
    return original_answers.indexOf(selected_option) > -1;
  }

  multiple_option_validation(original_answers, selected_options) {
    if (original_answers.length != selected_options.length) {
      return false;
    }
    var is_correct = true;
    selected_options.forEach(element => {
      if (original_answers.indexOf(element) === -1) {
        is_correct = false;
      }
    });
    return is_correct;
  }

  color_code_service(data) {
    var text = data.toLowerCase();
    console.log(text)
    var color = "";
    if (['english', 'eng'].indexOf(text) > -1) {
      return "#367a85"
    }

    if (['maths', 'math', 'mathematics', 'mathe matics'].indexOf(text) > -1) {
      return "#84a55e";
    }

    if (['science'].indexOf(text) > -1) {
      return "#d0aa47";
    }

    if (['ss', 'social science', 'socialscience'].indexOf(text) > -1) {
      return "#844029";
    }

    return '#' + Math.floor(0x1000000 * Math.random()).toString(16);
  }
}
